import React from 'react';

import Banner from '../Banner/Banner';
import BlockWrapper from './BlockWrapper';

const BannerBlock = ({ block }) => (
  <BlockWrapper>
    <Banner bannerData={block} />
  </BlockWrapper>
);

export default BannerBlock;
